(function() {
  'use strict';

  function initLocalizationSwitchers() {
    document.querySelectorAll('[data-localization-switcher]').forEach(function(switcher) {
      if (switcher.hasAttribute('data-localization-ready')) return;
      switcher.setAttribute('data-localization-ready', 'true');

      var form = switcher.querySelector('.localization-switcher__form');
      var countryInput = switcher.querySelector('[data-localization-country-input]');
      var countryOptions = Array.prototype.slice.call(
        switcher.querySelectorAll('[data-localization-country-option]')
      );
      var searchInput = switcher.querySelector('[data-localization-search]');

      if (!form) return;

      function invalidateProductCacheForLocaleChange() {
        if (window.HealixColors && typeof window.HealixColors.invalidateLocaleProductCache === 'function') {
          window.HealixColors.invalidateLocaleProductCache();
          return;
        }
        // Fallback for load-order/private-storage cases.
        try {
          var prefix = 'hxc.v1.prod.';
          var keys = [];
          for (var i = 0; i < window.localStorage.length; i++) {
            var key = window.localStorage.key(i);
            if (key && key.indexOf(prefix) === 0) keys.push(key);
          }
          keys.forEach(function (key) { window.localStorage.removeItem(key); });
        } catch (e) {}
      }

      form.addEventListener('submit', invalidateProductCacheForLocaleChange);

      countryOptions.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var code = btn.getAttribute('data-country-code');
          if (!code || !countryInput) return;

          countryInput.value = code;

          switcher.querySelectorAll('.localization-switcher__country-item').forEach(function(item) {
            item.classList.remove('is-active');
            item.removeAttribute('aria-selected');
          });
          var li = btn.closest('.localization-switcher__country-item');
          if (li) {
            li.classList.add('is-active');
            li.setAttribute('aria-selected', 'true');
          }

          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            invalidateProductCacheForLocaleChange();
            form.submit();
          }
        });
      });

      if (searchInput && countryOptions.length) {
        searchInput.addEventListener('input', function() {
          var query = (searchInput.value || '').trim().toLowerCase();
          countryOptions.forEach(function(btn) {
            var name = (btn.getAttribute('data-country-name') || '').toLowerCase();
            var code = (btn.getAttribute('data-country-code') || '').toLowerCase();
            var currency = (btn.getAttribute('data-country-currency') || '').toLowerCase();
            var match = !query || name.indexOf(query) !== -1 || code.indexOf(query) !== -1 || currency.indexOf(query) !== -1;
            var item = btn.closest('.localization-switcher__country-item');
            if (item) item.hidden = !match;
          });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLocalizationSwitchers);
  } else {
    initLocalizationSwitchers();
  }

  document.addEventListener('shopify:section:load', initLocalizationSwitchers);
})();
